import React, { useContext } from 'react';

import { app, variant } from '../context';
import { COLLECTS_PER_SECOND } from '../constants';

const datetime = time => {
  let t = parseInt(time, 10);
  const s = t % 60;
  t = parseInt(t / 60, 10);
  const m = t % 60;
  t = parseInt(t / 60, 10);
  const h = t % 24;
  t = parseInt(t / 24, 10);
  const d = t;

  return `${d} 日 ${h} 時間 ${m} 分 ${s} 秒`.replace(/^(0 \S+ )+/, '');
};

const Label = ({ num = 0, text = '', ...props }) => (
  <span className={`badge badge-${useContext(variant)} mx-1`} {...props}>
    {text || num.toLocaleString()}
  </span>
);

const Accent = props => (
  <div
    className={`list-group-item list-group-item-accent-${useContext(
      variant,
    )} bg-dark`}
    {...props}
  />
);

export default ({ upgrades, stack, time }) => {
  const { speed, bonus, doubled } = useContext(app);
  const spd = speed + upgrades * stack * bonus * (doubled ? 2 : 1);

  return (
    <div className="list-group list-group-accent mb-4">
      {upgrades === 0 ? null : (
        <Accent>
          <Label num={stack} />
          {'神器ごとに木石'}
          <Label num={stack / 2} />
          {'ずつと交換'}
        </Accent>
      )}
      <Accent>
        {'採集目標値'}
        <Label num={spd / COLLECTS_PER_SECOND} />
        {'までジーンを'}
        <Label num={upgrades} />
        {'回攻撃(10倍)'}
      </Accent>
      <Accent>
        {'合計必要時間'}
        <Label text={datetime(time)} />
      </Accent>
    </div>
  );
};
